// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".suspension_popover_list{width:95%!important;margin-left:56px}", ""]);
// Exports
module.exports = exports;
